import { Invoice } from '../../Invoices.types';
import { InvoiceDetailsContent } from '../InvoiceDetailsContent';
import { Modal } from '@/components/UI/Modal/Modal';

interface InvoiceDetailsModalProps {
  invoice: Invoice | null;
  onClose: () => void;
  onPay: () => void;
}

export function InvoiceDetailsModal({
  invoice,
  onClose,
  onPay,
}: InvoiceDetailsModalProps) {
  if (!invoice) {
    return null;
  }

  return (
    <Modal isOpen onClose={onClose} maxWidth={540} borderRadius={21} isInPortal>
      <InvoiceDetailsContent
        invoice={invoice}
        onClose={onClose}
        onPay={onPay}
      />
    </Modal>
  );
}
